module.exports = __webpack_public_path__ + "static/media/neutral_neutral.c32cb371.svg";